import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EntityCardContainer,
  EntityCardTitle,
  EntityCardItem,
} from '../../../entity/components/EntityCardComponents';
import { LawyerContext } from '../LawyerContext';

export const LawyerEducation: FC = () => {
  const {
    lawyerInfos: { education },
  } = useContext(LawyerContext);
  if (education) {
    window.dispatchEvent(
      new CustomEvent('createNav', {
        detail: 'professional-education',
      }),
    );
  }
  if (!education) return null;
  return (
    <EntityCardContainer id="professional-education">
      <EntityCardTitle>
        <FormattedMessage id="app.pages.lawyer.training.title" />
      </EntityCardTitle>
      <EntityCardItem>
        <pre>{education}</pre>
      </EntityCardItem>
    </EntityCardContainer>
  );
};
